import {
  AdapterSalesItemCategories,
  SalesItemBookingCategoryType,
  SalesItemCategory,
  SalesItemType,
  SalesItemTypeLabels
} from '@navio/nsdk';

export const getSalesItemDisplayName = (salesItem: { name: string; nameInternal?: string | null }) =>
  salesItem.nameInternal ?? salesItem.name;

export const isAdapterSalesItemCategory = (
  category: SalesItemCategory | null | undefined
): category is (typeof AdapterSalesItemCategories)[number] =>
  category != null && (AdapterSalesItemCategories as readonly SalesItemCategory[]).includes(category);

export const mapSaleItemCategoryToName = (category: SalesItemBookingCategoryType | null) => {
  if (!category) {
    return 'No category';
  }
  switch (category) {
    case SalesItemBookingCategoryType.WHEEL_SERVICES:
      return 'Wheel services';
    case SalesItemBookingCategoryType.WASH_SERVICES:
      return 'Wash services';
    case SalesItemBookingCategoryType.STONE_CHIP_REPAIR:
      return 'Stone chip repair';
  }
};

export const mapSaleItemCategoryToIcon = (category: SalesItemBookingCategoryType) => {
  switch (category) {
    case SalesItemBookingCategoryType.WHEEL_SERVICES:
      return 'WheelAngle';
    case SalesItemBookingCategoryType.WASH_SERVICES:
      return 'Droplet';
    case SalesItemBookingCategoryType.STONE_CHIP_REPAIR:
      return 'Wrench';
  }
};

/**
 * Non-SERVICE exceptions only. Everything else (including unknown future categories)
 * defaults to SERVICE — matches backend registry until the API exposes salesItemType.
 */
const SALES_ITEM_CATEGORY_TYPE_EXCEPTIONS: Partial<Record<SalesItemCategory, SalesItemType>> = {
  [SalesItemCategory.CAR_RIM]: SalesItemType.PRODUCT,
  [SalesItemCategory.CAR_TIRE]: SalesItemType.PRODUCT,
  [SalesItemCategory.SHOP_RIM]: SalesItemType.PRODUCT,
  [SalesItemCategory.SHOP_RIM_GENERIC_PREPAID]: SalesItemType.PRODUCT,
  [SalesItemCategory.SHOP_RIM_SALE_GENERIC]: SalesItemType.PRODUCT,
  [SalesItemCategory.SHOP_TIRE]: SalesItemType.PRODUCT,
  [SalesItemCategory.SHOP_TIRE_GENERIC]: SalesItemType.PRODUCT,
  [SalesItemCategory.SHOP_TIRE_GENERIC_PREPAID]: SalesItemType.PRODUCT,
  [SalesItemCategory.FEE]: SalesItemType.FEE
};

export const getSalesItemTypeFromCategory = (category?: SalesItemCategory | null): SalesItemType => {
  if (!category) {
    return SalesItemType.SERVICE;
  }
  return SALES_ITEM_CATEGORY_TYPE_EXCEPTIONS[category] ?? SalesItemType.SERVICE;
};

export const getSalesItemTypeLabel = (type: SalesItemType): string => SalesItemTypeLabels[type];

/** Service time is only settable (and required) for SERVICE; fee/product stay at 0. */
export const canSetServiceTimeForSalesItemType = (type: SalesItemType): boolean => type === SalesItemType.SERVICE;
